var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import styled from "styled-components";
import { Button, Paragraph, TextInput } from "grommet";
export var StyledTextInput = styled(TextInput)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  padding: 6px 42px;\n  line-height: 24px;\n  border-radius: 100px;\n",
    ]))
);
export var StyledBox = styled.div(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n"]))
);
export var StyledIcon = styled.div(
  _templateObject3 ||
    (_templateObject3 = _taggedTemplateLiteralLoose([
      "\n  position: absolute;\n  top: 5px;\n  left: 10px;\n",
    ]))
);
export var StyledButton = styled(Button)(
  _templateObject4 ||
    (_templateObject4 = _taggedTemplateLiteralLoose([
      "\n  background-color: black;\n  border-radius: 100px;\n  border: 1px;\n  text-align: center;\n  color: white;\n  padding: 6px 32px;\n",
    ]))
);
export var StyledParagraph = styled(Paragraph)(
  _templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  line-height: 24px;\n"]))
);
